import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/PurchasePage.css';
import { clearCart, getCart, getCartTotal } from './cartUtils';

const PurchasePage = () => {
  const navigate = useNavigate();
  const cart = getCart();
  const total = getCartTotal();
  
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '',
    notes: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.address || !formData.phone) {
      alert('يرجى ملء جميع الحقول المطلوبة');
      return;
    }

    const whatsappMessage = createWhatsAppMessage();
      // Open WhatsApp
  const whatsappWindow = window.open(
    `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`, 
    '_blank'
  );

  // Check if window opened successfully
  if (whatsappWindow) {
    // Clear cart and redirect after short delay
        setTimeout(() => {
        clearCart();
        navigate('/');
        }, 2000);
    } else {
        alert('لم يتم فتح واتساب. يرجى التحقق من إعدادات المتصفح.');
    }
  };

  const createWhatsAppMessage = () => {
    let message = `🎯 *طلب جديد من موقع MN *\n\n`;
    
    // Customer Information Table
    message += `*📋 معلومات العميل:*\n`;
    message += `├──────────────┼──────────────┐\n`;
    message += `│ *الاسم*       │ ${formData.name} │\n`;
    message += `├──────────────┼──────────────┤\n`;
    message += `│ *الهاتف*      │ ${formData.phone} │\n`;
    message += `├──────────────┼──────────────┤\n`;
    message += `│ *العنوان*     │ ${formData.address} │\n`;
    message += `└──────────────┴──────────────┘\n\n`;

    // Order Items Table
    message += `*📦 تفاصيل الطلب:*\n\n\n`;
        
    cart.forEach(item => {
      message += `│ ${item.quantity.toLocaleString('ar-EG').padEnd(4)} │ ${item.category.toLocaleString('ar-EG')} | ${item.name.toLocaleString('ar-EG').padEnd(20)} ${item.volume} │\n`;
    });
    // Additional Notes
    if (formData.notes) {
      message += `\n\n*ملاحظات:*\n${formData.notes}\n\n`;
    }

    message += `\n\n⏰ *وقت الطلب:* ${new Date().toLocaleString('ar-EG')}\n`;
    message += `🌐 *طلب عبر:* الموقع الإلكتروني\n\n`;
    message += `شكراً لثقتكم في  MN Cafe! 🧊`;

    return message;
  };

  if (cart.length === 0) {
    return (
      <div className="purchase-container">
        <div className="empty-cart-message">
          <h2>🛒 السلة فارغة</h2>
          <p>لا توجد عناصر في سلة التسوق</p>
          <button onClick={() => navigate('/')} className="back-to-menu-btn">
            ← العودة إلى القائمة
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="purchase-container" style={{marginTop:'50px'}}>
      <div className="purchase-content">
        {/* Order Summary */}
        <div className="order-summary">
          <h2>📋 ملخص الطلب</h2>
          <div className="order-items">
            {cart.map(item => (
              <div key={item.id} className="order-item">
                {item.image && <img src={item.image} alt={item.name} width="60" />}
                <div className="item-details">
                  <h4>{item.name}</h4>
                  <p>{item.price} جنيه × {item.quantity}</p>
                </div>
                <div className="item-total">
                  {item.price * item.quantity} جنيه
                </div>
              </div>
            ))}
          </div>
          <div className="order-total">
            <h3>الإجمالي: {total} جنيه</h3>
          </div>
        </div>

        {/* Customer Form */}
        <form className="customer-form" onSubmit={handleSubmit}>
          <h2>📝 معلومات التوصيل</h2>
          
          <div className="form-group">
            <label htmlFor="name">الاسم بالكامل *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="أدخل اسمك بالكامل"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">رقم الهاتف *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              placeholder="01XXXXXXXXX"
              pattern="01[0-9]{9}"
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">عنوان التوصيل *</label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
              placeholder="أدخل عنوان التوصيل بالتفصيل"
              rows="3"
            />
          </div>

          <div className="form-group">
            <label htmlFor="notes">ملاحظات إضافية (اختياري)</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              placeholder="أي ملاحظات خاصة بالطلب"
              rows="2"
            />
          </div>

          <button type="submit" className="submit-order-btn">
            💬 إرسال الطلب عبر واتساب
          </button>

          <button 
            type="button" 
            onClick={() => navigate('/')}
            className="back-btn"
          >
            ← العودة للتسوق
          </button>
        </form>
      </div>
    </div>
  );
};

export default PurchasePage;